var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareFacebook = function SvgShareFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 58 58"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0a29 29 0 1 0 29 29A29 29 0 0 0 29 0m4.56 29h-3.24v11.59h-4.87V29h-2.32v-4.17h2.32v-2.55a4.56 4.56 0 0 1 4.23-4.87 3.4 3.4 0 0 1 .64 0h3.48v3.94h-2.55c-.47 0-.93.23-.93 1.16v2.32H34Z"
  })));
};
export default SvgShareFacebook;